import { SignalRService } from './hub.js'


class SignalRServiceFactory {
    constructor() {
      this.instances = {};
    }
  
    getInstance(hubUrl) {
      if (!this.instances[hubUrl]) {
        this.instances[hubUrl] = new SignalRService(hubUrl);
      }
      return this.instances[hubUrl];
    }
  
    stopAll() {
      Object.values(this.instances).forEach(service => service.stop());
    }
  }

  export default new SignalRServiceFactory();